<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					:model="searchForm"
					@submit.native.prevent
        >

          <el-form-item label="审核标识:">
            <el-select
              v-model="searchForm.approveflag"
							@keyup.enter.native="seach"
							@visible-change="visibleType"
							ref="selectref"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in approveflag"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="员工:">
            <el-input
							v-model.trim="searchForm.username"
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
          <el-form-item label="教学点:">
            <el-input
							v-model.trim="searchForm.schoolorgname"
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
      border
      :header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column label="员工" prop="username" align="center" width="100">
        <template slot-scope="scope">
          <el-button @click="btnShowDetail(scope.row)" type="text">{{
            scope.row.username
          }}</el-button>
        </template>
      </el-table-column>

      <el-table-column label="开始时间" align="center" width="160">
        <template slot-scope="scope">
          {{ scope.row.starttime | formatDate("YYYY-MM-DD HH:mm:ss") }}
        </template></el-table-column
      >
      <el-table-column label="结束时间" align="center" width="160">
        <template slot-scope="scope">
          {{ scope.row.endtime | formatDate("YYYY-MM-DD HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
        label="请假天数"
        prop="days"
        align="center"
        width="50"
      ></el-table-column>
      <el-table-column
        label="请假事由"
        prop="reason"
        align="center"
        width="680"
      ></el-table-column>
      <el-table-column
        label="审核标识"
        prop="approveflag"
        align="center"
        width="70"
      >
        <template slot-scope="scope">
          {{ approveKeyVal[scope.row.approveflag] }}
        </template>
      </el-table-column>
      <el-table-column
        label="审批意见"
        prop="approvedesc"
        align="center"
        width="50"
      ></el-table-column>

      <el-table-column label="申请时间" align="center" width="160">
        <template slot-scope="scope">
          {{ scope.row.inserttime | formatDate("YYYY-MM-DD HH:mm:ss") }}
        </template>
      </el-table-column>

      <el-table-column
        label="教学点"
        prop="schoolorgname"
        align="center"
        width="130"
      ></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
			width="60%"
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
			:title="this.dialogTitle"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            :disabled="!$store.state.login.isMaxAuth"
            clearable
            @change="onChangeCompany($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="onChangeSchool($event, 'dynamicValidateForm')"
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工" prop="username">
          <el-input v-model="dynamicValidateForm.username" disabled />
          <el-button
            class="select-btn"
            type="primary"
            @click="
              onSelectData(
                user_dialogresult,
                'showUserModal',
                {schoolorgid:dynamicValidateForm.schoolorgid},
              )
            "
            >选择</el-button
          >
        </el-form-item>
        <el-form-item prop="starttime" label="开始时间：">
          <el-date-picker
            v-model="dynamicValidateForm.starttime"
            type="datetime"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endtime" label="结束时间：">
          <el-date-picker
            v-model="dynamicValidateForm.endtime"
            type="datetime"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="days" label="请假天数：">
          <el-input v-model.trim="dynamicValidateForm.days" clearable></el-input>
        </el-form-item>
        <el-form-item prop="reason" label="请假事由：">
          <el-input
            type="textarea"
            v-model.trim="dynamicValidateForm.reason"
						clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择员工 -->
    <el-dialog
      class="btn-2b5a95"
      width="50%"
			v-dialogDrag
      @close="onCloseSelect"
      title="选择员工："
      :visible.sync="showUserModal"
			v-if="showUserModal"
			:close-on-click-modal='false'
      append-to-body
    >
      <el-button type="primary" @click="onConfirmUser">确定</el-button>

      <div class="index_2 btn-2b5a95">
        <div
          class="l-w"
          :style="{
            height: $store.state.global.isSearchExtend_2
              ? ''
              : $store.state.global.searchFormHeight_2 + 10 + 'px',
          }"
        >
          <el-form
            label-position="right"
            :class="
              $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
            "
            :model="selectSearchForm"
						@submit.native.prevent
          >
            <el-form-item label="真实姓名:" prop="realname">
              <el-input
								v-model.trim="selectSearchForm.realname"
								@keyup.enter.native="onSelectSearchClick(selectTableUrl,null,Object.assign({schoolorgid:dynamicValidateForm.schoolorgid},selectSearchForm))"
								clearable />
            </el-form-item>
          </el-form>
        </div>
        <div class="r-w">
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="!$store.state.global.isEndRequest"
            class="btn-2b5a95"
            @click="onSelectSearchClick(selectTableUrl,null,Object.assign({schoolorgid:dynamicValidateForm.schoolorgid},selectSearchForm))"
            >搜索</el-button
          >
					<el-button type="primary" @click="handleQuery">重置</el-button>
          <el-button
            type="primary"
            :icon="
              $store.state.global.isSearchExtend_2
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            v-if="$store.state.global.searchExtend_2"
            class="btn-2b5a95"
            @click="onExtendClick('isSearchExtend_2')"
            >{{ $store.state.global.searchExtendText_2 }}</el-button
          >
        </div>
      </div>


      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				border
				:key="key"
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
        ></el-table-column>
        <el-table-column
          label="真实姓名"
          prop="realname"
          align="center"
        ></el-table-column>
        <el-table-column
          label="员工编号"
          prop="code"
          align="center"
        ></el-table-column>
        <el-table-column
          label="登录账号"
          prop="name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="所属部门"
          prop="departorgname"
          align="center"
        ></el-table-column>
        <el-table-column
          label="教学点"
          prop="schoolorgname"
          align="center"
        ></el-table-column>
        <el-table-column
          label="分公司"
          prop="companyorgname"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="(val, data)=>handleSelectChange(val,Object.assign({schoolorgid:dynamicValidateForm.schoolorgid},selectSearchForm))"
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="
          selectTable.paginationutil ? selectTable.paginationutil.totalcount : 0
        "
      ></el-pagination>
    </el-dialog>

    <!-- 审批 -->
    <el-dialog
      class="btn-2b5a95"
      width="35%"
			v-dialogDrag
      title="审批："
			:close-on-click-modal='false'
      :visible.sync="showApproveModal"
      append-to-body
    >
      <el-form
        :model="approveForm"
        ref="approveForm"

        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >

        <el-form-item
                label="审核是否通过："
                prop="passflag"
                :rules="[
            {
              required: true,
              message: '必填字段',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
                  v-model="approveForm.passflag"
                  placeholder="请选择"
                  clearable
          >
            <el-option
                    v-for="item in [
                { value: 1, label: '通过' },
                { value: 0, label: '不通过' },
              ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="approvedesc" label="审批意见：">
          <el-input
            type="textarea"
            v-model.trim="approveForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitApproveForm('approveForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog
      class="btn-2b5a95"
			:close-on-click-modal='false'
      :width="$store.state.global.isFullscreen ? 'width: 100%' : 'width: 80%'"
      :fullscreen="$store.state.global.isFullscreen"
      :visible.sync="showDetailModal"
      v-if="showDetailModal"
      append-to-body
      @closed="$store.state.global.isFullscreen = false"
    >
      <span slot="title" class="el-dialog__title">
        <span>详情</span>
        <span
          :class="
            $store.state.global.isFullscreen
              ? 'el-icon-copy-document'
              : 'el-icon-full-screen'
          "
          @click="isExpand($store.state.global.isFullscreen)"
        ></span>
      </span>
      <table border="1" cellpadding="10" cellspacing="0" class="base_table" >
        <tr>
          <td>开始时间：{{ dynamicValidateForm.starttime | formatDate("YYYY-MM-DD HH:mm:ss")  }}</td>
          <td>结束时间：{{ dynamicValidateForm.endtime | formatDate("YYYY-MM-DD HH:mm:ss") }}</td>
          <td>请假天数：{{ dynamicValidateForm.days }}天</td>
        </tr>
        <tr>
          <td>请假事由：{{ dynamicValidateForm.reason }}</td>
          <td v-if="dynamicValidateForm.approveflag === -2">审核标识：未提请审批</td>
					<td v-if="dynamicValidateForm.approveflag === -1">审核标识：审核中</td>
					<td v-if="dynamicValidateForm.approveflag === 0">审核标识：未通过</td>
					<td v-if="dynamicValidateForm.approveflag === 1">审核标识：通过</td>
          <td>审批意见：{{ dynamicValidateForm.approvedesc }}</td>
        </tr>
        <tr>
          <td>录入时间：{{ dynamicValidateForm.inserttime | formatDate("YYYY-MM-DD HH:mm:ss") }}</td>
          <td>用户名称：{{ dynamicValidateForm.username }}</td>
          <td>性别：{{ dynamicValidateForm.sexval }}</td>
        </tr>
        <tr>
          <td>部门：{{ dynamicValidateForm.departorgname }}</td>
          <td>职位：{{ dynamicValidateForm.positionname }}</td>
          <td>教学点：{{ dynamicValidateForm.schoolorgname }}</td>
        </tr>
        <tr>
          <td>分公司：{{ dynamicValidateForm.companyorgname }}</td>
					<td>流水号： {{dynamicValidateForm.id}}</td>
					<td></td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import {
  askleave_list,
  askleave_input,
  askleave_save,
  askleave_delete,
  askleave_requestapprove,
  askleave_approvecheck,
  askleave_approvesave,
  askleave_export,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import { _user_dialogresult } from "@/request/api/public";
import {
  _approveflag,
  _approveflags,
  _approveLevel,
  _approveLevels,
  _isApprovePass,
  _isApprovePasss,
} from "@/assets/js/filedValueFlag";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";

export default {
  mixins: [part],
  name: "askleave",
  components: {},
  props: {
    user_dialogresult: {
      default: () => _user_dialogresult,
    },
  },
  data() {
    //数值表单规则
    var checkfield = (rule, value, callback) => {
      if (!(value + "")) {
        return callback(new Error("必填字段"));
      } else {
        if (isNaN(Number(value))) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }
    };
    return {
      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, // 添加
      showUserModal: false, // 员工
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      selectTable: {},
      selectTableUrl: null,

      selectSchoolorgid: null,
      selectSearchForm: {},
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      approveflag: _approveflags,
      rules: {
        starttime: [{ trigger: "blur", message: "必填字段", required: true }],
        endtime: [{ trigger: "blur", message: "必填字段", required: true }],
        days: [{ trigger: "blur", validator: checkfield, required: true }],
        reason: [{ trigger: "blur", message: "必填字段", required: true }],
        approveflag: [{ trigger: "blur", message: "必填字段", required: true }],
        passflag: [{ trigger: "blur", message: "必填字段", required: true }],
        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        username: [{ trigger: "blur", message: "必填字段", required: true }],
      }, //表单规则
      dialogTitle: "", //对话框标题
      approveKeyVal: _approveflag,
      approveForm: {}, //审批表单
      showApproveModal: false,
			key: '',
      approveLevel: _approveLevel, //审批等级
      approveLevels: _approveLevels,
      isApprovePass: _isApprovePass, //审核是否通过标记
      isApprovePasss: _isApprovePasss,
      showDetailModal: false,
    };
  },
  created() {
    //this.searchForm.id = this.$route.params.id;
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["org_combox", "org_comboxchild"]),
    //改变分公司 change
    onChangeCompany(val, form) {
      this[form].schoolorgname = "";
      this[form].companyorgid = val;
      this.org_comboxchild(val);
    },
    //改变教学点 change
    onChangeSchool(val, form) {
      this[form].schoolorgid = val;
    },
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.selectref.blur();
			}
		},
		reset() {
			this.searchForm = {
				approveflag: null,
				username: null,
				schoolorgname: null
			}
		},
		//重置
		resetQuery() {
			this.reset();
			this.getDataList();
		},
		selectQuery() {
			this.selectSearchForm = {
				realname: null
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, {schoolorgid: this.dynamicValidateForm.schoolorgid});
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: askleave_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row));
      this.showDetailModal = true;
    },
    //添加click
    btnAdd() {
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        schoolorgid: this.$store.state.login.userinfo.schoolorgid,
        companyorgid: this.$store.state.login.userinfo.companyorgid,
      };
      this.$set(
        this.dynamicValidateForm,
        "companyorgname",
        this.$store.state.login.userinfo.companyorgname
      );
      this.$set(
        this.dynamicValidateForm,
        "schoolorgname",
        this.$store.state.login.userinfo.schoolorgname
      );
      this.org_comboxchild(this.dynamicValidateForm.companyorgid);
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
      this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },
    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //提请审批 click
    btnRequestApprove() {
      selectCheck(this.multipleSelection, "提请审批", false, () => {
        confirmCallBack({
          title: "提示",
          content: "选中的条目将提请审批！",
          success: () => {
            this.reqApproval(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },

    //教学点负责人审核 click
    btnSchoolHead2() {
      selectCheck(this.multipleSelection, "教学点负责人审核", false, () => {
        this.approveForm = {
          passflag: null,
          approvedesc: null,
        };
        this.approveForm.askleaveid = this.multipleSelection[0].id;
        this.approveForm.leadertype = "02";
        this.showApproveModal = true;
      });
    },
    //教学点负责人审核 click (多选)
    btnSchoolHead() {
      selectCheck(this.multipleSelection, "教学点负责人审核", true, () => {
        myRequest({
          method: "post",
          url: askleave_approvecheck,
          data: this.$qs.stringify(
                  {
                    ids: this.multipleSelection.map((i) => i.id),
                    leadertype: "02",
                  },
                  {
                    arrayFormat: "repeat",
                  }
          ),
        }).then((res) => {
          if (res.data.code === "200") {
            this.approveForm = {
              passflag: null,
              approvedesc: null,
            };
            this.showApproveModal = true;
          }
        });
      });
    },
    //总裁审核 click
    btnPresidentApprove() {
      selectCheck(this.multipleSelection, "总裁审核", false, () => {
        this.approveForm = {};
        this.approveForm.askleaveid = this.multipleSelection[0].id;
        this.approveForm.leadertype = "01";
        this.showApproveModal = true;
      });
    },
    //刷新 click
    btnRefresh() {
      this.getDataList();
    },
    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: askleave_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showAddModal = true;
          this.dynamicValidateForm = res.data.data.vaskleave;
          this.org_comboxchild(this.dynamicValidateForm.companyorgid);
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
          this.dynamicValidateForm.starttime = formatDare(
            this.dynamicValidateForm.starttime,
            "YYYY-MM-DD HH:mm:ss"
          );
          this.dynamicValidateForm.endtime = formatDare(
            this.dynamicValidateForm.endtime,
            "YYYY-MM-DD HH:mm:ss"
          );
        }
      });
    },

    //提交-（添加，修改） api
    submitAddOrEditForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: askleave_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,
            }
          ).then((res) => {
            if (res.data.code === "200") {
              this.showAddModal = false;
            }
          });
        }
      });
    },
    //审批 api
    submitApproveForm2(approveForm) {
      this.approveForm.passflag = this.isApprovePass[this.approveForm.passflag];
      this.$refs[approveForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: askleave_approvesave,
              data: this.approveForm,
            },
            {
              that: this,
              isRefTableList: true,
              modal: "showApproveModal",
            }
          );
        }
      });
    },

    //负责人审批 api
    submitApproveForm(approveForm) {
      this.$refs[approveForm].validate((valid) => {
        if (valid) {
          myRequest(
                  {
                    method: "post",
                    url: askleave_approvesave,
                    data: this.$qs.stringify(
                            {
                              askleaveids: this.multipleSelection.map((i) => i.id),
                              passflag: this.approveForm.passflag,
                              approvedesc: this.approveForm.approvedesc,
                              leadertype: "02",
                            },
                            {
                              arrayFormat: "repeat",
                            }
                    ),
                  },
                  {
                    isRefTableList: true,
                    that: this,

                    modal: "showApproveModal",
                  }
          );
        }
      });
    },

    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: askleave_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //提请审批 api
    reqApproval(ids) {
      myRequest(
        {
          method: "post",
          url: askleave_requestapprove,
          data: this.$qs.stringify(
            {
              id: ids,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },

    //切换选项表格页
    handleSelectChange(val,data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl,null,data);
			this.onCloseSelect();
    },
    //选中表格数据改变时 change
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },


    //选项表格(员工) api
    onSelectData(url, modal, data) {
      this.selectTableUrl = url;
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data || {}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
					this.key = Math.random();
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url,modal,data){
      this.selectPageInfo.pageindex = 1
      this.onSelectData(url,modal,data)
    },
    //关闭选项框 click
    onCloseSelect(){
      this.selectPageInfo.pageindex = 1
    },

    //确认员工 click
    onConfirmUser() {
      selectCheck(this.multipleSelection, "确认考核人", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "username",
          this.multipleSelection[0].realname
        );
        this.dynamicValidateForm.userid = this.multipleSelection[0].id;
        this.showUserModal = false;
				this.selectQuery();
				this.multipleSelection = [];
      });
    },

    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //导出成绩
    btnExport() {
      confirmCallBack({
        title: "提示",
        content: "根据搜索条件进行导出。",
        success: () => {
          window.location.href =
                  this.$url.Freemarker +
                  askleave_export +
                  `?${createObjParams(this.searchForm)}`;
        },
        fail: () => {
          messageTip({
            message: "取消操作",
            type: "info",
          });
        },
      });
    },

  },
};
</script>


<style  lang="scss">
</style>
